module.exports = __webpack_public_path__ + "img/04.dcfcf84e.png";